import { j as i } from "./jsx-runtime-3tyXYecC.mjs";
import { m as o } from "./tss-DN0acMKN.mjs";
import { g as s } from "./get-encore-value-Di648HqV.mjs";
import { B as l } from "./base-icon-v2-DZwX3wnO.mjs";
const c = o()((r, t) => {
  const { size: a, color: n } = t;
  return {
    svg: {
      fill: s(n, {
        /* eslint-disable sort-keys */
        "bamboo-brand-medium": r.constructs.icon.bambooBrand.medium,
        "discovery-weak": r.palette.discovery.light,
        "discovery-medium": r.palette.discovery.main,
        "discovery-strong": r.palette.discovery.dark,
        "error-weak": r.palette.error.light,
        "error-medium": r.palette.error.main,
        "error-strong": r.palette.error.dark,
        "info-weak": r.palette.info.light,
        "info-medium": r.palette.info.main,
        "info-strong": r.palette.info.dark,
        link: r.palette.link.main,
        "neutral-extra-weak": r.palette.gray[300],
        "neutral-weak": r.palette.gray[400],
        "neutral-medium": r.palette.gray[500],
        "neutral-strong": r.palette.gray[600],
        "neutral-extra-strong": r.palette.gray[800],
        "neutral-extra-extra-strong": r.palette.gray[900],
        "neutral-forced-white": r.palette.common.white,
        "neutral-inverted": r.palette.common.white,
        "notice-strong": r.constructs.icon.notice.strong,
        "primary-medium": r.palette.primary.light,
        "primary-strong": r.palette.primary.main,
        "success-weak": r.palette.success.light,
        "success-medium": r.palette.success.main,
        "success-strong": r.palette.success.dark,
        "warning-weak": r.palette.warning.light,
        "warning-medium": r.palette.warning.main,
        "warning-strong": r.palette.warning.dark
        /* eslint-enable sort-keys */
      }),
      flexShrink: 0,
      height: `${a}px`,
      width: `${a}px`
    }
  };
}), m = (r) => {
  const { ariaLabel: t, containerRef: a, name: n } = r, { classes: e } = c(r);
  return /* @__PURE__ */ i.jsx(
    l,
    {
      ariaLabel: t,
      className: e.svg,
      containerRef: a,
      "data-fabric-component": "IconV2",
      name: n
    }
  );
};
export {
  m as I
};
//# sourceMappingURL=icon-v2-DGtVEk7e.mjs.map
